import { PHASE_EXPORT, PHASE_PRODUCTION_BUILD, PHASE_PRODUCTION_SERVER, PHASE_DEVELOPMENT_SERVER, PHASE_TEST, PHASE_INFO } from 'next/constants';
import { z } from 'zod';

const variables = {
    NODE_ENV: process.env.NODE_ENV,
    PHASE: process.env.PHASE
};
const publicVariablesSchema = z.object({
    NODE_ENV: z.enum([
        "development",
        "production",
        "test"
    ]),
    // PHASE may be undefined when configs are loaded (e.g. next.config.ts evaluation).
    // Make it optional so builds that load this package before Next sets PHASE won't fail.
    PHASE: z.enum([
        PHASE_EXPORT,
        PHASE_PRODUCTION_BUILD,
        PHASE_PRODUCTION_SERVER,
        PHASE_DEVELOPMENT_SERVER,
        PHASE_TEST,
        PHASE_INFO
    ]).optional()
});
const privateVariablesSchemaClient = z.object({
});
const privateVariablesSchemaServer = z.object({
});
const envSchema = z.intersection(publicVariablesSchema, typeof window === "undefined" ? privateVariablesSchemaServer : privateVariablesSchemaClient);
const env = envSchema.parse(variables);

let logger = console;
if (typeof window === "undefined") {
    // Only import winston on the server side
    // This prevents winston from being bundled in the client-side code
    // and avoids issues with the browser environment.
    const logPath = "logs";
    import('winston').then((winston)=>{
        logger = winston.createLogger({
            exitOnError: false,
            format: winston.format.json(),
            level: "debug",
            transports: [
                new winston.transports.Console({
                    forceConsole: true
                })
            ]
        });
        logger.add(new winston.transports.File({
            filename: `${logPath}/error.log`,
            level: "error"
        }));
        logger.add(new winston.transports.File({
            filename: `${logPath}/info.log`,
            level: "info"
        }));
        logger.add(new winston.transports.File({
            filename: `${logPath}/debug.log`,
            level: "debug"
        }));
        if (env.NODE_ENV !== "production") {
            logger.add(new winston.transports.Console({
                format: winston.format.simple()
            }));
        }
    });
}
var logger_default = logger;

export { logger_default as default, logger };
